import { useState, useEffect } from 'react'
import { fetchStoreDetails } from './httpService'

export function useStoreFinderHook(retailerSiteId) {
  const [storeDetails, setStoreDetails] = useState()
  useEffect(() => {
    async function fetchData() {
      try {
        let storeData = await fetchStoreDetails(retailerSiteId)
        setStoreDetails(storeData)
      } catch (error) {}
    }
    if (retailerSiteId) {
      fetchData()
    }
  }, [retailerSiteId])
  return storeDetails
}
